import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import ErrorMessageBuilder from '../ErrorMessages/ErrorMessageBuilder';

const RegisterError = ({ error }) => {
  const unpackedError = error;
  const { t } = useTranslation();
  let errorComponent = <Box />;
  const now = new Date();
  if (error !== undefined) {
    if (unpackedError?.statusCode === 401 && unpackedError?.message === 'Token is expired') {
      errorComponent = (
        <ErrorMessageBuilder failureTitle={t('register_failure')} failureMessage={t('page_expiration_after_send')} />
      );
    } else if (now > unpackedError.expiration) {
      errorComponent = (
        <ErrorMessageBuilder expirationTime={unpackedError?.expiration.toString()} failureMessage={t('page_expired')} />
      );
    } else if (unpackedError?.statusCode === 401 && unpackedError?.message === 'Token is invalid') {
      errorComponent = <ErrorMessageBuilder failureMessage={t('register_failure_invalid')} />;
    } else if (unpackedError?.statusCode === 401 && unpackedError?.message === 'Token is missing') {
      errorComponent = <ErrorMessageBuilder failureMessage={t('register_failure_missing')} />;
    } else if (unpackedError?.statusCode === 500) {
      errorComponent = (
        <ErrorMessageBuilder failureTitle={t('register_failure')} failureMessage={unpackedError.message} />
      );
    } else {
      errorComponent = (
        <ErrorMessageBuilder failureTitle={t('register_failure')} failureMessage={t('register_failure_unknown')} />
      );
    }
  }

  return errorComponent;
};

RegisterError.propTypes = {
  error: PropTypes.object,
};

export default RegisterError;
